import { render, staticRenderFns } from "./CompletedForms.vue?vue&type=template&id=dad84012"
import script from "./CompletedForms.vue?vue&type=script&lang=js"
export * from "./CompletedForms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports